'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _draftJs = require('draft-js');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../../utils');

var _alignLeft = require('../../../../icon/align-left.svg');

var _alignLeft2 = _interopRequireDefault(_alignLeft);

var _alignCenter = require('../../../../icon/align-center.svg');

var _alignCenter2 = _interopRequireDefault(_alignCenter);

var _alignRight = require('../../../../icon/align-right.svg');

var _alignRight2 = _interopRequireDefault(_alignRight);

var _undo = require('../../../../icon/undo.svg');

var _undo2 = _interopRequireDefault(_undo);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars

var Image = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(Image, _Component);

    function Image() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Image);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Image.__proto__ || (0, _getPrototypeOf2.default)(Image)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            hovered: false,
            isSelected: false,
            reloading: false
        }, _this.onImgChange = function (event) {
            var file = event.target.files[0];
            if (file.type.indexOf('image/') === 0) {
                var src = URL.createObjectURL(file);
                var block = _this.props.block;

                var entityKey = block.getEntityAt(0);
                _draftJs.Entity.mergeData(entityKey, { src: src });
                _this.setState({
                    reloading: true
                });
                _this.props.blockProps.imageUploader(file).then(function (data) {
                    var editorState = _this.props.blockProps.getEditorState();
                    var contentState = editorState.getCurrentContent().mergeEntityData(entityKey, { src: data.src });
                    var newerState = _draftJs.EditorState.push(editorState, contentState, 'apply-entity');
                    _this.setState({
                        reloading: false
                    });
                    _this.props.blockProps.setEditorState(_draftJs.EditorState.forceSelection(newerState, newerState.getSelection()));
                });
            }
        }, _this.setEntityAlignment = function (alignment) {
            var block = _this.props.block;

            var entityKey = block.getEntityAt(0);
            _draftJs.Entity.mergeData(entityKey, { alignment: alignment });
            _this.setState({
                hovered: true
            });
        }, _this.setEntityAlignmentLeft = function () {
            _this.setEntityAlignment('left');
        }, _this.setEntityAlignmentRight = function () {
            _this.setEntityAlignment('right');
        }, _this.setEntityAlignmentCenter = function () {
            _this.setEntityAlignment('center');
        }, _this.focusBlock = function () {
            var _this$props = _this.props,
                block = _this$props.block,
                blockProps = _this$props.blockProps;
            var getEditorState = blockProps.getEditorState,
                setEditorState = blockProps.setEditorState;

            var key = block.getKey();
            var editorState = getEditorState();
            var currentblock = (0, _utils.getCurrentBlock)(editorState);
            if (currentblock.getKey() === key) {
                return;
            }
            var newSelection = new _draftJs.SelectionState({
                anchorKey: key,
                focusKey: key,
                anchorOffset: 0,
                focusOffset: 1
            });
            setEditorState(_draftJs.EditorState.forceSelection(editorState, newSelection));
        }, _this.reloadImg = function () {
            _this.imgReloader.value = null;
            _this.imgReloader.click();
        }, _this.toggleEnter = function () {
            _this.setState({
                hovered: true
            });
        }, _this.toggleLeave = function () {
            _this.setState({
                hovered: false
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Image, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            var block = props.block,
                blockProps = props.blockProps;
            var getEditorState = blockProps.getEditorState;

            var key = block.getKey();
            var editorState = getEditorState();
            var currentblock = (0, _utils.getCurrentBlock)(editorState);
            this.setState({
                isSelected: currentblock.getKey() === key
            });
        }
        // upload image

        // 图片获取焦点

        // add new image

    }, {
        key: 'renderAlignmentOptions',
        value: function renderAlignmentOptions() {
            return _react2.default.createElement(
                'div',
                { className: 'rde-image-toolbar' },
                _react2.default.createElement(
                    'button',
                    { className: 'rde-block-button', onClick: this.setEntityAlignmentLeft },
                    _react2.default.createElement('img', { src: _alignLeft2.default, alt: 'Left' })
                ),
                _react2.default.createElement(
                    'button',
                    { className: 'rde-block-button', onClick: this.setEntityAlignmentCenter },
                    _react2.default.createElement('img', { src: _alignCenter2.default, alt: 'Center' })
                ),
                _react2.default.createElement(
                    'button',
                    { className: 'rde-block-button', onClick: this.setEntityAlignmentRight },
                    _react2.default.createElement('img', { src: _alignRight2.default, alt: 'Right' })
                ),
                _react2.default.createElement(
                    'button',
                    { className: 'rde-block-button', onClick: this.reloadImg },
                    _react2.default.createElement('img', { src: _undo2.default, alt: 'ReloadImage' })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                block = _props.block,
                contentState = _props.contentState;

            var entityKey = block.getEntityAt(0);
            var blockData = {
                src: '',
                alignment: undefined
            };
            if (entityKey) {
                var entity = contentState.getEntity(entityKey);
                blockData = entity.getData();
            }
            var _blockData = blockData,
                src = _blockData.src,
                alignment = _blockData.alignment,
                loading = _blockData.loading;
            // const { hovered } = this.state;

            return _react2.default.createElement(
                'div',
                {
                    className: alignment ? 'rde-image-' + alignment : 'rde-image-center',
                    onClick: this.focusBlock,
                    role: 'presentation'
                },
                _react2.default.createElement(
                    'div',
                    {
                        onMouseEnter: this.toggleEnter,
                        onMouseLeave: this.toggleLeave,
                        className: 'rde-image-wrapper'
                    },
                    (loading || this.state.reloading) && _react2.default.createElement(
                        'div',
                        { className: 'rde-image-loader' },
                        _react2.default.createElement(
                            'div',
                            { className: 'spinner' },
                            _react2.default.createElement('div', { className: 'double-bounce1' }),
                            _react2.default.createElement('div', { className: 'double-bounce2' })
                        )
                    ),
                    _react2.default.createElement('img', {
                        className: 'rde-image-content' + (this.state.isSelected ? ' rde-image-is-selected' : ''),
                        alt: '',
                        src: src
                    }),
                    this.state.hovered && !loading && this.renderAlignmentOptions(),
                    _react2.default.createElement('input', {
                        type: 'file',
                        accept: 'image/jpg,image/png,image/gif,image/jpeg',
                        ref: function ref(_ref2) {
                            _this2.imgReloader = _ref2;
                        },
                        onChange: this.onImgChange,
                        style: { display: 'none' }
                    })
                )
            );
        }
    }]);
    return Image;
}(_react.Component), _class.propTypes = {
    block: _propTypes2.default.object,
    contentState: _propTypes2.default.object,
    blockProps: _propTypes2.default.object
}, _temp2);
exports.default = Image;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/src/blocks/Image/index.js
// module id = 129
// module chunks = 0